import { Temporal } from '@js-joda/core'

export default abstract class TemporalConverterBase {
  abstract localizationOptions: Intl.DateTimeFormatOptions

  public abstract getValue(): Temporal
  public abstract toNative(): Date

  public toIsoString(): string {
    return this.getValue().toString()
  }

  public toUtcString(): string {
    return this.toNative().toUTCString()
  }

  public toLocalizedString(
    locales: string | string[] = 'en-US',
    options: Intl.DateTimeFormatOptions = this.localizationOptions,
  ) {
    return Intl.DateTimeFormat(locales, options).format(this.toNative())
  }
}
